import { Background } from "@/modules/internal_api/image";
import { EditorStore, useEditorStore } from "@/stores/editor_store";
import { PersistentStore } from "@/stores/persistent_store";

interface EditorPresetState {
  background: null | Background;
  backgroundColor: null | string;
  blur: Boolean;
  shadow: Boolean;
  backgroundSamplesCollectionIds: string[];
  backgroundColorSamples: string[];
}

export const useEditorPresetState = () => {
  const presetStateDefault: EditorPresetState = {
    background: null,
    backgroundColor: null,
    blur: false,
    shadow: false,
    backgroundSamplesCollectionIds: [],
    backgroundColorSamples: [],
  };

  const editorStore: EditorStore = useEditorStore();

  const clearPresetState = (presetState: EditorPresetState) => {
    presetState.background = null;
    presetState.backgroundColor = null;
    presetState.blur = false;
    presetState.shadow = false;
  };

  const transferPresetState = (presetState: EditorPresetState, persistentStore: PersistentStore) => {
    const presetBackgroundExists = presetState.background?.thumbnail_url;

    if (presetBackgroundExists) {
      persistentStore.setSelectedBackgroundPhoto(presetState.background as Background);
    }

    if (presetState.backgroundColor) {
      persistentStore.setSelectedBackgroundColor(presetState.backgroundColor);
    }

    editorStore.backgroundSamplesCollectionIds = presetState.backgroundSamplesCollectionIds;
    editorStore.backgroundColorSamples = presetState.backgroundColorSamples;
  };

  const openTabAndPanel = (presetState: EditorPresetState) => {
    const presetBackgroundExists = presetState.background?.thumbnail_url;
    if (presetState.blur || presetState.shadow) {
      editorStore.togglePanel("fx");
    } else if (presetBackgroundExists || presetState.backgroundColor) {
      if (presetBackgroundExists) {
        editorStore.openedBackgroundTab = "photo";
      } else if (presetState.backgroundColor) {
        editorStore.openedBackgroundTab = "color";
      }
      editorStore.togglePanel("addBackground");
    }
  };

  const applyPresetState = async (
    presetState: EditorPresetState,
    persistentStore: PersistentStore,
    revealResult: () => Promise<any>
  ) => {
    transferPresetState(presetState, persistentStore);

    await revealResult();

    openTabAndPanel(presetState);

    if (presetState.shadow) {
      persistentStore.setShadowLayerVisible(true);
    }

    if (!presetState.backgroundColor && presetState.blur) {
      persistentStore.setBackgroundBlurEnabled(true);
    }

    clearPresetState(presetState);
  };

  return { applyPresetState, presetStateDefault };
};
